import "./IconPhone.scss";

export const IconPhone = () => {
  return <span className="icon-phone"></span>;
};
